import { Instance } from 'mobx-state-tree';
import { StoreDriverPushTokenDtoModelBase } from './StoreDriverPushTokenDtoModel.base';

/* The TypeScript type of an instance of StoreDriverPushTokenDtoModel */
export interface StoreDriverPushTokenDtoModelType extends Instance<typeof StoreDriverPushTokenDtoModel.Type> {}

/* A graphql query fragment builders for StoreDriverPushTokenDtoModel */
export { selectFromStoreDriverPushTokenDto, storeDriverPushTokenDtoModelPrimitives, StoreDriverPushTokenDtoModelSelector } from './StoreDriverPushTokenDtoModel.base';

/**
 * StoreDriverPushTokenDtoModel
 */
export const StoreDriverPushTokenDtoModel = StoreDriverPushTokenDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
